export var ADS_URL = 'https://ads-query.luizalabs.com';
export var MAGALU_ADS_EVENT_READY = 'magalu.ads.events.ready';
export var MAGALU_ADS_READY = 'magalu.ads.ready';
export var SEACH_PAGE = 'BUSCA';
export var SINGLE_PRODUCT_PAGE = 'PDP';